import { service, model } from 'eco-cli'
import { Menu, MenuTree, InValue, LabelFile, Article } from '@/models/index.js'
import {VipArticle} from '@/models/Article'
const { finance } = service;
const { Filter, Sort, Page } = model;

// 获取menu数据
export const getMenuData = () => finance.withToken.get("dir/tree/getExclusiveDirInfoData").then(res => res.map(v => Menu.fromServer(v)))

// 获取首页列表数据
export const getListData = () => finance.withToken.get("vip/getExclusivePageDataInfo").then(res => res.map(v => Menu.fromServer(v)))

// 获取更多左侧树数据
export const getMenuMoreData = () => finance.withToken.get("dir/tree/getMoreInfoDirData").then(res => res.map(v => MenuTree.fromServer(v)))

// 获取更多右侧数据
export const getRightMoreData = ({
  filter = Filter.new(), sort = Sort.new(), page = Page.new(), ...args
}) => finance.withToken.post("vip/getMoreData", {
  ...filter.toServer(),
  ...sort.toServer(),
  ...page.toServer(),
  ...args
}).then(res => {
  return {
    labelList: res.tagList?.map(v => InValue.new(v.name, v.id)),
    vipData: res.vipData?.records.map(v => VipArticle.fromServer(v)),
    page: Page.fromServer(res.vipData)
  }
})

// 获取搜索页面数据
export const getSearchData = ({
  filter = Filter.new(), sort = Sort.new(), page = Page.new(), ...args
}) => finance.withToken.post("vip/searchVipData", {
  ...filter.toServer(),
  ...sort.toServer(),
  ...page.toServer(),
  ...args
}).then(res => {
  return {
    vipData: res.records.map(v => VipArticle.fromServer(v)),
    page: Page.fromServer(res)
  }
})

// 获取搜索页面menu数据
export const getSearchMenuData = () => finance.withToken.get("dir/tree/getAllDirData").then(res => res.map(v => InValue.new(v.name, v.id)))

// 获取详情页面数据
export const getArticleDetails = (id) =>
  finance.withToken.get("community/finance/queryFinanceById", { id })
    .then((res) => {
      return Article.fromServer(res);
    });

// 点赞
export const addArticleSupport = (id) =>
  finance.withToken.withoutErrorAlert.post("community/favorite/add", { dataId: id })
